<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card color="primary" icon="mdi-file-compare" inline class="ml-0 px-5 py-4">
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">Visualização da Aderência BDGD: {{ nome }}</div>
          </template>

          <v-tabs v-model="tab" class="my-10" background-color="grey lighten-3" color="white" grow slider-size="65">
            <v-tabs-slider class="mt-1" color="primary" />

            <v-tab :ripple="false">Analítico</v-tab>
            <v-tab :ripple="false">Gráfico</v-tab>
          </v-tabs>

          <v-row v-if="tab == 0" justify="center" class="mx-auto">
            <v-col cols="12">
              <v-data-table
                dense
                :headers="headersAnalitico"
                :items="dados"
                :headerProps="{
                  sortByText: 'Ordenar Por'
                }"
                :items-per-page="-1"
                hide-default-footer
                mobile-breakpoint="0"
              >
                <template v-slot:item="row">
                  <tr>
                    <td>{{ row.item['TUC'] }}</td>
                    <td>{{ row.item['Aderência TUC'] }}%</td>
                    <td>{{ row.item['Aderência TUC.A1'] }}%</td>
                    <td>{{ row.item['Aderência TUC.A1 até A6'] }}%</td>
                    <td>{{ row.item['Aderência Qualitativa Ponderada'] }}%</td>
                    <td>{{ row.item['VOC TUC'] }}%</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row v-if="tab == 1" justify="center" class="mx-auto">
            <v-col cols="12">
              <highcharts :options="graficoOptions" />
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AderenciaBdgdService from '@/services/AderenciaBdgdService';

  export default {
    name: 'VisualizarAderenciaBdgd',

    data() {
      return {
        tab: 0,
        headersAnalitico: [
          {
            text: 'TUC',
            value: 'TUC'
          },
          {
            text: 'Aderência TUC',
            value: 'Aderência TUC'
          },
          {
            text: 'Aderência TUC.A1',
            value: 'Aderência TUC.A1'
          },
          {
            text: 'Aderência TUC.A1 até A6',
            value: 'Aderência TUC.A1 até A6'
          },
          {
            text: 'Aderência Qualitativa Ponderada',
            value: 'Aderência Qualitativa Ponderada'
          },
          {
            text: 'VOC TUC',
            value: 'VOC TUC'
          }
        ],
        dados: [],
        nome: ''
      };
    },

    computed: {
      graficoOptions() {
        let data = {
          tucs: [],
          aderenciaTuc: [],
          aderenciaTucA1: [],
          aderenciaTucA1A6: [],
          qualitativaPonderada: [],
          vocTuc: []
        };
        const colors = ['#4472c4', '#ed7d31', '#ffc000', '#fc2403', '#a5a5a5'];

        this.dados.forEach((el) => {
          data.tucs.push(`TUC ${el['TUC']}`);
          data.aderenciaTuc.push(el['Aderência TUC']);
          data.aderenciaTucA1.push(el['Aderência TUC.A1']);
          data.aderenciaTucA1A6.push(el['Aderência TUC.A1 até A6']);
          data.qualitativaPonderada.push(el['Aderência Qualitativa Ponderada']);
          data.vocTuc.push(el['VOC TUC']);
        });

        return {
          chart: {
            zoomType: 'xy'
          },
          title: {
            text: undefined
          },
          subtitle: {
            text: undefined
          },
          xAxis: [
            {
              categories: data.tucs,
              crosshair: true
            }
          ],
          yAxis: [
            {
              labels: {
                format: '{value}'
              },
              title: {
                text: 'Aderência (%)'
              }
            }
          ],
          tooltip: {
            shared: true
          },
          series: [
            {
              name: 'Aderência TUC',
              type: 'column',
              data: data.aderenciaTuc,
              color: colors[0],
              tooltip: {
                valueSuffix: '%'
              }
            },
            {
              name: 'Aderência TUC.A1',
              type: 'column',
              data: data.aderenciaTucA1,
              color: colors[1],
              tooltip: {
                valueSuffix: '%'
              }
            },
            {
              name: 'Aderência TUC.A1 até A6',
              type: 'column',
              data: data.aderenciaTucA1A6,
              color: colors[2],
              tooltip: {
                valueSuffix: '%'
              }
            },
            {
              name: 'Aderência Qualitativa Ponderada',
              type: 'column',
              data: data.qualitativaPonderada,
              color: colors[3],
              tooltip: {
                valueSuffix: '%'
              }
            },
            {
              name: 'VOC TUC',
              type: 'line',
              data: data.vocTuc,
              color: colors[4],
              tooltip: {
                valueSuffix: '%'
              }
            }
          ]
        };
      }
    },

    mounted() {
      this.getDados();
    },

    methods: {
      getDados() {
        const id = this.$route.params.id;

        AderenciaBdgdService.getDadosGrafico(id)
          .then((response) => {
            this.nome = response.data.nome;
            this.dados = response.data.analitico.map((obj) => {
              for (const prop in obj) {
                if (prop != 'TUC') {
                  obj[prop] = Math.round(obj[prop] * 10000) / 100;
                }
              }
              return obj;
            });
          })
          .catch((err) => {
            console.log('Erro: ', err);

            this.$toast.error('Erro ao recuperar dados do gráfico.', '', { position: 'topRight' });
            this.$router.push({ name: 'Aderencia BDGD Historico' });
          });
      }
    }
  };
</script>

<style lang="sass">
  .v-tabs-bar
    height: 56px !important
    padding: 0 0px

  .v-tabs-slider-wrapper
    overflow: visible

  .v-tabs-slider
    border-radius: 4px

  .v-tabs-slider-wrapper
    contain: initial
    z-index: 0
</style>
